import React, { useState, useRef, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import Logo from "../Logo";
import { useAuth } from "../WordyWhiz/context/AuthContext";

function NavComponent() {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [acctOpen, setAcctOpen] = useState(false);
  const acctRef = useRef(null);

  const isActive = (path) => location.pathname === path ? "nav-active" : "";
  const isActivePrefix = (prefix) => location.pathname.startsWith(prefix) ? "nav-active" : "";

  useEffect(() => {
    function handleClick(e) {
      if (acctRef.current && !acctRef.current.contains(e.target)) setAcctOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  useEffect(() => { setMenuOpen(false); setAcctOpen(false); }, [location.pathname]);

  return (
    <nav className="site-nav">
      <Link to="/" className="site-nav__logo">
        <Logo size={19} lens="var(--ww-ink)" lensText="var(--ww-cream)" arm="var(--ww-rose)" />
      </Link>

      <button
        className="site-nav__toggle"
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      <ul className={`site-nav__links${menuOpen ? " open" : ""}`}>
        <li><Link to="/wordy-whiz/dictionaries" className={isActivePrefix("/wordy-whiz/dictionar")}>Learn</Link></li>
        <li><Link to="/wordy-whiz/play" className={isActivePrefix("/wordy-whiz/play") || isActivePrefix("/wordy-whiz/stacks")}>Play</Link></li>
        <li><Link to="/about" className={isActive("/about")}>About</Link></li>
        <li><Link to="/contact" className={isActive("/contact")}>Contact</Link></li>

        {isLoggedIn ? (
          <li ref={acctRef} style={{ position: "relative" }}>
            <button
              className="site-nav__acct-toggle"
              onClick={() => setAcctOpen((o) => !o)}
            >
              Account ▾
            </button>
            <div className={`site-nav__acct-dropdown${acctOpen ? " open" : ""}`}>
              <Link to="/wordy-whiz/my-dictionaries">My Dictionaries</Link>
              <Link to="/wordy-whiz/upload">Upload Dictionary</Link>
              <div className="site-nav__acct-divider" />
              <Link to="/wordy-whiz/account">Manage Account</Link>
            </div>
          </li>
        ) : (
          <>
            <li><Link to="/wordy-whiz/login" className={isActive("/wordy-whiz/login")}>Log In</Link></li>
            <li><Link to="/wordy-whiz/signup" className={isActive("/wordy-whiz/signup")}>Sign Up</Link></li>
          </>
        )}
      </ul>

      <Link to="/contact" className="site-nav__cta">Say hello</Link>
    </nav>
  );
}

export default NavComponent;
